export default __webpack_public_path__ + "static/media/pantry1-afterH-2048w.c9944e49.avif";